import anime from "animejs";

export default {
    name: 'products',
    component() {
        return {
            init() {

                let title = document.querySelector("[data-title]");
                let text = document.querySelector("[data-text]");

                let staggerItems = [title, text];
                document.querySelectorAll("[data-prods]").forEach((prod) => {
                    staggerItems.push(prod);
                })

                setTimeout(() => {
                    anime({
                        targets: staggerItems,
                        opacity: 1,
                        delay: anime.stagger(200),
                    });
                }, 300);

            
            },
        }
    }
}